export default __webpack_public_path__ + "static/media/database.886d7444.svg";